import {
  ListItem,
  ListItemAvatar,
  ListItemProps,
  ListItemText,
  Skeleton,
  Stack,
} from '@mui/material';

interface BrightyListItemSkeletonProps extends ListItemProps {
  variant?: 'default' | 'withButton' | 'transaction';
}

export function SkeletonListItem({ variant = 'default', ...props }: BrightyListItemSkeletonProps) {
  return (
    <ListItem {...props}>
      <ListItemAvatar>
        <Skeleton variant="circular" width={40} height={40} />
      </ListItemAvatar>
      <ListItemText secondary={<Skeleton variant="text" width={96} />}>
        <Skeleton variant="text" width={48} />
      </ListItemText>
      {variant === 'withButton' && <Skeleton variant="rounded" width={42} height={28} />}
      <Stack
        direction="column"
        sx={{
          justifyContent: 'flex-start',
          height: '100%',
          paddingTop: '6px',
        }}
      >
        {variant === 'transaction' && <Skeleton variant="rounded" width={42} height={12} />}
      </Stack>
    </ListItem>
  );
}
